import { IReqCongelamentoUnico, IReqItensCongelamentoUnicoModal } from "../../../../pages/CongelamentoCNPJ/Congelamentos/AbaCongelamentoUnicoCNPJ/interface";
import { api } from "../../../apiAxios";
import { getToken } from "../../../LStorage/token";
import { urlHttpGov } from "../../../urls";

class CongelamentoUnicoService {
    private readonly baseURL = `${urlHttpGov}/congelamento-cnpj`;

    async getCongelamentos(signal?: AbortSignal): Promise<Array<IReqCongelamentoUnico>> {

        const { data } = await api.get(`${this.baseURL}`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            signal
        });

        return data;
    }

    async getItensCongelamento(idCnpj: string | number, signal?: AbortSignal): Promise<Array<IReqItensCongelamentoUnicoModal>> {

        const { data } = await api.get(`${this.baseURL}/${idCnpj}`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            signal
        });

        return data;
    }

    async getCongelamentosBaixarTodos(id: string | number, signal?: AbortSignal) {

        const { data } = await api.get(`${this.baseURL}/${id}/zip`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            responseType: 'blob',
            signal
        });

        return data;
    }

    async getCongelamentosBaixarUnico(
        id: string | number,
        cnai: string | number,
        signal?: AbortSignal
    ): Promise<{ signedUrl: string }> {

        const { data } = await api.get(`${this.baseURL}/${id}/arquivo/${cnai}/link`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            signal
        });

        return data;
    }

    async postCongelamentoCertidoes(
        idCnpj: string | number,
        signal?: AbortSignal
    ) {

        const { data } = await api.post(`${this.baseURL}/certidoes`,
            { cnpj: idCnpj },
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
                signal
            });

        return data
    }

    async postCongelamentoCertidoesFinep(
        idCnpj: string | number,
        signal?: AbortSignal
    ) {

        const { data } = await api.post(`${this.baseURL}/certidoes-finep`,
            { cnpj: idCnpj },
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
                signal
            });

        return data
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new CongelamentoUnicoService();
